import React from 'react'
import styled from 'styled-components'
import { Block, Spinner, Text } from '@mote/ui'
import { AccountProfileAvatar } from './AccountProfileAvatar'
import { AccountProfileThemeSelection } from './AccountProfileThemeSelection'
import { useAccountProfileQuery } from '@mote/api'
import { useAuth } from '../../../auth/useAuth'

export const AccountProfile = ({ account }) => {
  const { user, updateUser } = useAuth()

  const { data, loading, error } = useAccountProfileQuery()
  return (
    <Root gap={32} margin='16px 0 0 0'>
      <Block gap={16}>
        <Text fontWeight={500} fontSize={15} color='#25252D'>
          My Avatar
        </Text>

        <AccountProfileAvatar
          avatarUrl={user.avatarUrl}
          name={account.name}
          updateUser={updateUser}
        />
      </Block>

      <Divider />
      {!loading && error && (
        <Text fontSize={15} color='#F44336'>
          Failed to load theme preference
        </Text>
      )}
      {loading && <Spinner radius={30} />}
      {!loading && !error && (
        <AccountProfileThemeSelection
          userName={account.name}
          currentTheme={data?.profile?.theme ?? 'classic'}
          avatarUrl={user.avatarUrl}
        />
      )}
    </Root>
  )
}

const Root = styled(Block)``
const Divider = styled.div`
  height: 1px;
  background: #ececf3;
`
